import type { Business, List } from '@/modules/dashboard/dashboardTypes';
import type { DirectEmail } from '@/modules/email/emailTypes';
import Email from '@/modules/email/scenes/Email';
import type { User } from '@/modules/user/userTypes';
import { sendAnalytics } from '@/services/analyticsService';
import { useCallback, useState } from 'react';
import type { FilterProps } from '../Filters';

type ComposeEmailModalProps = FilterProps & {
	isOpen: boolean;
	onCloseModal: VoidFunction;
	businessSelected?: Business;
	directEmail?: DirectEmail;
	listId?: List['id'];
	userEmail: User['email'];
};

export const ComposeEmailModal = ({
	appliedFilters,
	onFilterChange,
	isOpen,
	businessSelected,
	onCloseModal,
	directEmail,
	listId,
	userEmail
}: ComposeEmailModalProps) => {
	const [sendAllMode, setSendAllMode] = useState(false);

	const handleComposeEmailModalClose = useCallback(() => {
		sendAnalytics({
			type: 'track',
			userId: userEmail,
			eventName: 'Email Modal Closed'
		});

		onCloseModal();
	}, [onCloseModal, userEmail]);

	const handleToggleSendAllMode = (mode: boolean) => {
		setSendAllMode(mode);
	};

	return (
		<Email.Modal
			linkedInSharer={() => null}
			onClose={handleComposeEmailModalClose}
			show={isOpen}
			business={businessSelected}
			directEmail={directEmail}
			sendAllMode={sendAllMode}
			setSendAllMode={handleToggleSendAllMode}
			listId={listId}
			appliedFilters={appliedFilters}
			onFilterChange={onFilterChange}
		/>
	);
};
